import React from 'react';
import styled from 'styled-components';
import { device } from '../styles/size';

const Wrapper = styled.footer`
  background-color: #f7f8fa;
  padding: 20px 0;
`;

const Container = styled.div`
  display: flex;
  flex-flow: column;
  max-width: 1140px;
  margin: 0 auto;
`;

const Main = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  & * {
    flex: 0 0 50%;
  }

  @media ${device.tablet} {
    flex-flow: column;
    align-items: center;
  }
`;

const Disclaimer = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 10px;
  color: #808080;
  font-weight: 400;

  border-top: 1px solid #808080;
  padding-top: 10px;
  margin-top: 10px;
  & * {
    flex: 0 0 50%;
  }

  & a,
  & a:visited,
  & a:link {
    text-decoration: none;
    color: #808080;
  }

  @media ${device.tablet} {
    flex-flow: column-reverse;
    align-items: center;

    & * {
      margin: 7px 0;
    }
  }
`;

const Logo = styled.div`
  & img {
    width: 123px;
    margin: 20px 0;
  }
`;

const Contact = styled.div`
  & p {
    margin: 7px 0;
    font-size: 14px;
    font-weight: 400;
  }

  & b {
    margin: 7px 0;
    font-size: 14px;
    font-weight: 600;
  }

  @media ${device.tablet} {
    text-align: center;
    margin: 10px 0;
  }
`;

const Social = styled.a`
  width: 41px;
  padding: 8px;
  margin-right: 5px;
`;

const Brand = styled.svg`
  width: 41px;
  fill: #898f9c;
`;

const Footer = () => {
  return (
    <Wrapper>
      <Container>
        <Main>
          <Logo>
            <img alt="ippd logo" src="./logo/IPPD__Vertical_Color.png" />
          </Logo>
          <Contact>
            <b>สถาบันนโยบายสาธารณะและการพัฒนา</b>
            <p>
              สามย่านมิตรทาวน์ ชั้น 29 ยูนิต 2906 ถนนพญาไท แขวงวังใหม่
              เขตปทุมวัน กรุงเทพมหานคร 10330
            </p>
            <p>contact@ippd.or.th</p>
            <p>
              <Social
                href="https://www.facebook.com/ippd.or.th"
                target="_blank"
              >
                <Brand xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
                </Brand>
              </Social>
              <Social href="https://page.line.me/ippd" target="_blank">
                <Brand
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 296.528 296.528"
                >
                  <path d="M295.838,115.347l0.003-0.001l-0.092-0.76c-0.001-0.013-0.002-0.023-0.004-0.036c-0.001-0.011-0.002-0.021-0.004-0.032   l-0.344-2.858c-0.069-0.574-0.148-1.228-0.238-1.974l-0.072-0.594l-0.147,0.018c-3.617-20.571-13.553-40.093-28.942-56.762   c-15.317-16.589-35.217-29.687-57.548-37.878c-19.133-7.018-39.434-10.577-60.337-10.577c-28.22,0-55.627,6.637-79.257,19.193   C23.289,47.297-3.585,91.799,0.387,136.461c2.056,23.111,11.11,45.11,26.184,63.621c14.188,17.423,33.381,31.483,55.503,40.66   c13.602,5.642,27.051,8.301,41.291,11.116l1.667,0.33c3.921,0.776,4.975,1.842,5.247,2.264c0.503,0.784,0.24,2.329,0.038,3.18   c-0.186,0.785-0.378,1.568-0.57,2.352c-1.529,6.235-3.11,12.683-1.868,19.792c1.428,8.172,6.531,12.859,14.001,12.86   c0.001,0,0.001,0,0.002,0c8.035,0,17.18-5.39,23.231-8.956l0.808-0.475c14.436-8.478,28.036-18.041,38.271-25.425   c22.397-16.159,47.783-34.475,66.815-58.17C290.172,175.745,299.2,145.078,295.838,115.347z M92.343,160.561H66.761   c-3.866,0-7-3.134-7-7V99.865c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7v46.696h18.581c3.866,0,7,3.134,7,7   C99.343,157.427,96.209,160.561,92.343,160.561z M119.03,153.371c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V99.675   c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M182.304,153.371c0,3.033-1.953,5.721-4.838,6.658   c-0.712,0.231-1.441,0.343-2.161,0.343c-2.199,0-4.323-1.039-5.666-2.888l-25.207-34.717v30.605c0,3.866-3.134,7-7,7   c-3.866,0-7-3.134-7-7v-52.16c0-3.033,1.953-5.721,4.838-6.658c2.886-0.936,6.045,0.09,7.827,2.545l25.207,34.717V99.675   c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M233.311,159.269h-34.645c-3.866,0-7-3.134-7-7v-26.847V98.573   c0-3.866,3.134-7,7-7h33.57c3.866,0,7,3.134,7,7s-3.134,7-7,7h-26.57v12.849h21.562c3.866,0,7,3.134,7,7c0,3.866-3.134,7-7,7   h-21.562v12.847h27.645c3.866,0,7,3.134,7,7S237.177,159.269,233.311,159.269z"></path>
                </Brand>
              </Social>
              <Social
                href="https://www.linkedin.com/company/ippdthailand/"
                target="_blank"
              >
                <Brand
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 38.12 38.12"
                >
                  <path
                    id="icon_linkedin"
                    d="M19.06,0A19.06,19.06,0,1,0,38.12,19.06,19.062,19.062,0,0,0,19.06,0ZM13.521,28.813H8.879V14.848h4.642ZM11.2,12.941h-.03a2.419,2.419,0,1,1,.061-4.825,2.42,2.42,0,1,1-.031,4.825ZM30.259,28.813H25.618V21.342c0-1.878-.672-3.158-2.352-3.158a2.541,2.541,0,0,0-2.382,1.7,3.179,3.179,0,0,0-.153,1.133v7.8H16.09s.061-12.655,0-13.965h4.642v1.977a4.608,4.608,0,0,1,4.183-2.305c3.054,0,5.344,2,5.344,6.285Zm0,0"
                    fill="#8e94a0"
                  ></path>
                </Brand>
              </Social>
              <Social href="https://twitter.com/ippdth" target="_blank">
                <Brand xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm116.886719 199.601562c.113281 2.519532.167969 5.050782.167969 7.59375 0 77.644532-59.101563 167.179688-167.183594 167.183594h.003906-.003906c-33.183594 0-64.0625-9.726562-90.066406-26.394531 4.597656.542969 9.277343.8125 14.015624.8125 27.53125 0 52.867188-9.390625 72.980469-25.152344-25.722656-.476562-47.410156-17.464843-54.894531-40.8125 3.582031.6875 7.265625 1.0625 11.042969 1.0625 5.363281 0 10.558593-.722656 15.496093-2.070312-26.886718-5.382813-47.140624-29.144531-47.140624-57.597657 0-.265624 0-.503906.007812-.75 7.917969 4.402344 16.972656 7.050782 26.613281 7.347657-15.777343-10.527344-26.148437-28.523438-26.148437-48.910157 0-10.765624 2.910156-20.851562 7.957031-29.535156 28.976563 35.554688 72.28125 58.9375 121.117187 61.394532-1.007812-4.304688-1.527343-8.789063-1.527343-13.398438 0-32.4375 26.316406-58.753906 58.765625-58.753906 16.902344 0 32.167968 7.144531 42.890625 18.566406 13.386719-2.640625 25.957031-7.53125 37.3125-14.261719-4.394531 13.714844-13.707031 25.222657-25.839844 32.5 11.886719-1.421875 23.214844-4.574219 33.742187-9.253906-7.863281 11.785156-17.835937 22.136719-29.308593 30.429687zm0 0"></path>
                </Brand>
              </Social>
            </p>
          </Contact>
        </Main>
        <Disclaimer>
          <span>
            Copyright &copy; {new Date().getFullYear()} Institute of Public
            Policy and Development. All rights reserved.
          </span>
          <a href="http://www.ippd.or.th/privacy-policy/" target="_blank">
            Privacy Policy
          </a>
        </Disclaimer>
      </Container>
    </Wrapper>
  );
};

export default Footer;
